import api from './api.js'
let util = {
    // 返回登录页面
    goLogin:function () {
      let href = window.location.href;
      var url = href.split('#')[0] + '#/login';
      window.location.href = url;
      // window.location.href = window.location.host;
    },
    // 手机号测试
    regPhone:function (data) {
      let reg = /1\d{10}/;
      return reg.test(data);
    },
    // base64转换
    toBase64:function(str){
      var base64String = str/*base64图片串*/;
      //这里对base64串进行操作，去掉url头，并转换为byte
      var bytes = window.atob(base64String.split(',')[1]);
      //处理异常，将ASCII码小于0的转换为大于0，这里有两种写法
      //         第一种：
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for(var i = 0; i < bytes.length; i++){
        ia[i] = bytes.charCodeAt(i); //这里有点疑惑，ia是怎么改变ab的？注：①
      }
      //Blob对象
      var blob = new Blob([ab], {type: 'image/jpeg'}); //type为图片的格式
      //FormData对象

      //TDOD Ajax或者其他方式上传FormData对象
      //FormData对象接受三个参数，第三个参数为文件名，通常我们只传前两个参数，第三个参数不传则使用默认文件名，这里使用的Blob对象，所以需要一个文件名，用时间戳代替。
      return blob;
    },
    // 时间格式转换
    timeFormat:function (time,type) {
      if(!time)time= new Date();
      if(!type)type='datetime';
      var _Date = new Date(time);
      var y,m,d,h,min,sec,result;
      switch (type){
        case 'datetime':
           y = _Date.getFullYear();
           m = _Date.getMonth()+1;
           d = _Date.getDate();
           h = _Date.getHours();
           min = _Date.getMinutes();
           sec = _Date.getSeconds();
            result =  y +'-'+
            (m <10 ? '0'+m : m) +'-'+
            (d <10 ? '0'+d : d) +' '+
            (h <10 ? '0'+h : h)+':'+
            (min <10 ? '0'+min : min)+':'+
            (sec <10 ? '0'+sec : sec);
           break;
      }
      return result;
    },
    urlFormat:function(data){
      if(typeof data == 'string'){
        data = '???'+ data;
        data = data.replace(/\?{3,}/g,'');
        let arr = data.split('&');
        let obj = {};
        arr.forEach(item=>{
          let subArr = item.split("=");
          obj[subArr[0]] = subArr[1];
        });
        return obj;
      }else if(typeof data == 'object'){
        let arr = [];
        for(let key in data){
          arr.push(key+'='+data[key]);
        }
        let str = arr.join('&');
        return str||'';
      }
    },
};

export default { util }



// WEBPACK FOOTER //
// ./src/comm/util.js